import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { LayerProvider, registerIcons } from '@astryxdesign/core';
import { Theme } from '@astryxdesign/core/theme';
import { neutralIconRegistry, neutralTheme } from '@astryxdesign/theme-neutral/built';

import './styles.css';
import { router } from './router';
import { hydrateSession } from './stores/auth';

// Themes ship the icon set; register it once so every component resolves icons
// from the global registry (works before any React tree exists).
registerIcons(neutralIconRegistry);

// Resolve any stored session before the first paint so guarded routes don't
// flash the login screen for an already-signed-in user.
void hydrateSession();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <Theme theme={neutralTheme} mode="system">
      <LayerProvider>
        <RouterProvider router={router} />
      </LayerProvider>
    </Theme>
  </StrictMode>,
);
